import RequestNewPassword from '../../templates/views/Account/RequestNewPassword';

export default {
  path: '/request-new-password',
  name: 'RequestNewPassword',
  component: RequestNewPassword,
  meta: {
    title: 'Request New Password',
  },
};
